
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { CiMenuKebab } from "react-icons/ci";
import CustomModel from "../../../../components/common/CustomModel";
import CustomSelect from "../../../../components/common/CustomSelect";
import ProspectPropertyService from "../../../Service/ProspectPropertyService";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../components/Constant/Notification";
import { userUid } from "../../../../utils/storage";
import { Divider, MenuItem } from "../../../../components/Constant/Constant";
import {
  FiXCircle,
  FiAlertCircle,
  FiEdit,
  FiCheckCircle,
} from "react-icons/fi";
import ProcurementImages from "../../../Constants/ProcurementImages";
import {
  getPriorityBadgeColor,
  periotyQueryEnum,
  queryCategories,
} from "../../../Enum/QueryEnum";
import UserService from "../../../../GlobalSetupComponents/Services/UserService";
import {
  formatDate,
  formatDateForInput,
  formatToIndianDate,
} from "../../../../utils/dateFormatter";
import CustomSidebar from "../../../../components/common/CustomSidebar";
import AdvocateService from "../../../Service/AdvocateService";
import MediaUpload from "../../../../components/SetupComponents/PropertiesComponents/MediaUpload";
import { queryUserList } from "../../../../GlobalSetupComponents/Enum/RoleEnum";
import CustomAdvocateList from "./CustomAdvocateList";
import { Query } from "@tanstack/react-query";
import QuertyAddReponseList from "./QuertyAddReponseList";
import QueriesHistoryPage from "./QueriesHistoryPage";

const QueriesInfoPage = ({ propertyId , queryData , isDropped, setProgressTrigger }) => {
  const [isResolveModalOpen, setIsResolveModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(queryData || null);
  const [actionType, setActionType] = useState(null);
  const [resolveComment, setResolveComment] = useState("");
  const [editFormData, setEditFormData] = useState({
    title: "",
    description: "",
    category: "",
    givenBy: "",
    targetDate: "",
    priority: "",
    associatedLegalOpinion: "",
    files: [],
  });
  const [loading, setLoading] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [users, setUsers] = useState([]);
  const [advocateOpinions, setAdvocateOpinions] = useState([]);

  const fetchQueryInfoById = async (queryId) => {
    try {
        const response = await ProspectPropertyService.getPropertyQueryById(queryId);
        const queryData = response.data.query || response.data;
        
       
        const mappedQuery = {
          id: queryData.id || queryId,
          title: queryData.title,
          description: queryData.description,
          category: queryData.category,
          givenBy: queryData.givenBy,
          targetDate: queryData.targetDate,
          status: queryData.status,
          priority: queryData.priority,
          prospectPropertyId: queryData.prospectPropertyId,
          statusReason: queryData.statusReason,
          statusTimestamp: queryData.statusTimestamp,
          statusComment: queryData.statusReason,
          responseDescription: queryData.responseDescription,
          responseGivenDate: queryData.responseGivenDate,
          responseGivenBy: queryData.responseGivenBy,
          associatedLegalOpinion: queryData.associatedLegalOpinion,
          fileUrl: queryData.fileUrl,
          createdBy: queryData.createdBy,
          modifiedBy: queryData.modifiedBy,
          createdTimestamp: queryData.createdTimestamp,
          // For backward compatibility, also add these fields
          givenByName: queryData.givenBy?.name
        };
        
        return mappedQuery;
    } catch (error) {
        console.error("Error fetching query by ID:", error);
        return null;
    }
  }
  
  useEffect(() => {
    if (selectedQuery && selectedQuery.id) {
        fetchQueryInfoById(selectedQuery.id).then((data) => {
            if (data) {
              setSelectedQuery(data);
            }
        });
    }
}, [selectedQuery?.id]);

  const fetchAdvocateOpinion = async () => {
    try {
      const response = await AdvocateService.getAdvocateOpinionPropertyId(propertyId);
      setAdvocateOpinions(response.data.data?.advocateAnalysisRecords || []);
    } catch (error) {
      console.error("Error fetching advocate opinion:", error);
    }
  };
  useEffect(() => {
    fetchAdvocateOpinion();
  }, [propertyId]);

  const fetchRoleBasedUsers = async () => {
    try {
      const body = { roleIds: queryUserList };
      const response = await UserService.getUserRoleBasedNames(body);
      setUsers(response.data.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
      showErrorToast("Failed to fetch users.");
    }
  };



  const handleMenuClick = async (query, action) => {
    setActiveDropdown(null);
    setSelectedQuery(query);
    setActionType(action);

    switch (action) {
      case "resolve":
      case "ignore":
      case "drop":
        setResolveComment("");
        setIsResolveModalOpen(true);
        break;
      case "edit":
        if (query) {
          // Find the selected user based on the givenBy object structure
          const selectedUser = users.find((u) => u.value === query.givenBy?.id || u.id === query.givenBy?.id);
          const selectedPriority = periotyQueryEnum.find((p) => p.value === query.priority);
          const selectedCategory = queryCategories.find((c) => c.value === query.category);
          const selectedOpinion = advocateOpinions.find((o) => o.id === query.associatedLegalOpinion?.id);
        
          setEditFormData({
            title: query.title || "",
            description: query.description || "",
            priority: selectedPriority ? { value: selectedPriority.value, label: selectedPriority.label } : null,
            category: selectedCategory ? { value: selectedCategory.value, label: selectedCategory.label } : null,
            givenBy: selectedUser ? { 
              value: selectedUser.value || selectedUser.id, 
              label: selectedUser.label || selectedUser.name 
            } : (query.givenBy ? {
              value: query.givenBy.id,
              label: query.givenBy.name
            } : null),
            targetDate: formatDateForInput(query.targetDate) || "",
            associatedLegalOpinion: selectedOpinion ? { 
              value: selectedOpinion.id, 
              label: `${advocateOpinions.findIndex(o => o.id === selectedOpinion.id) + 1}. ${selectedOpinion.type}` 
            } : null,
            files: query.fileUrl ? [query.fileUrl] : [],
          });
          setIsEditModalOpen(true);
        }
        break;
      default:
        break;
    }
  };

  const handleConfirmAction = async () => {
    if (!selectedQuery) return;
    let response;
    try {
      switch (actionType) {
        case "resolve":
          response = await ProspectPropertyService.updatePropertyQueryStatus({
            propertyId: propertyId,
            status: "RESOLVED",
            queryId: selectedQuery.id,
            reason: resolveComment,
            modifiedBy: userUid,
          });
          if (response.status === 200 || response.status === 201) {
            showSuccessToast(response.data.message);
          }
          break;
        case "ignore":
          response = await ProspectPropertyService.updatePropertyQueryStatus({
            propertyId: propertyId,
            queryId: selectedQuery.id,
            status: "IGNORED",
            reason: resolveComment,
            modifiedBy: userUid,
          });
          if (response.status === 200 || response.status === 201) {
            showSuccessToast(response.data.message);
          }
          break;
        case "drop":
          response = await ProspectPropertyService.updatePropertyQueryStatus({
            propertyId: propertyId,
            queryId: selectedQuery.id,
            status: "DROPPED",
            reason: resolveComment,
            modifiedBy: userUid,
          });
          if (response.status === 200 || response.status === 201) {
            showSuccessToast(response.data.message);
            // Trigger progress update when query is dropped
            if (setProgressTrigger) {
              setProgressTrigger(prev => !prev);
            }
          }
          break;
      }
      setIsResolveModalOpen(false);
      setResolveComment("");
      setActionType(null);
      // Refresh the selected query data
      if (selectedQuery?.id) {
        fetchQueryInfoById(selectedQuery.id).then((data) => {
          if (data) {
            setSelectedQuery(data);
          }
        });
      }
    } catch (error) {
      console.error(`Error performing ${actionType} on query:`, error);
    }
  };

  const handleUpdateQuery = async () => {
    if (!selectedQuery) return;

    if (
      !editFormData.title ||
      !editFormData.description ||
      !editFormData.priority ||
      !editFormData.category ||
      !editFormData.givenBy ||
      !editFormData.targetDate ||
      (editFormData.category?.value === "Advocate Analysis" && !editFormData.associatedLegalOpinion)
    ) {
      showErrorToast("Please fill all required fields.");
      return;
    }

    setLoading(true);
    try {
      const updateData = {
        queryId : selectedQuery.id,
        title: editFormData.title,
        description: editFormData.description,
        priority: editFormData.priority?.value,
        category: editFormData.category?.value,
        givenBy: editFormData.givenBy?.value,
        givenByName: editFormData.givenBy?.label,
        fileUrl: editFormData.files?.length > 0 ? editFormData.files[0] : selectedQuery.fileUrl || "",
        targetDate: formatDate(editFormData.targetDate),
        associatedLegalOpinion: editFormData.associatedLegalOpinion?.value || null,
        modifiedBy: userUid,
      };

      await ProspectPropertyService.updatePropertyQuery(updateData);
      showSuccessToast("Query updated successfully");
      setIsEditModalOpen(false);
      // Refresh the selected query data
      if (selectedQuery?.id) {
        fetchQueryInfoById(selectedQuery.id).then((data) => {
          if (data) {
            setSelectedQuery(data);
          }
        });
      }
    } catch (error) {
      console.error("Error updating query:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSelectChange = (name, selected) => {
    setEditFormData((prev) => ({
      ...prev,
      [name]: selected || null,
    }));
  };

  const getActionTitle = () => {
    switch (actionType) {
      case "resolve":
        return "Resolve Query";
      case "ignore":
        return "Ignore Query";
      case "drop":
        return "Drop Property";
      default:
        return "Confirm Action";
    }
  };

  const getActionButtonText = () => {
    switch (actionType) {
      case "resolve":
        return "Resolve";
      case "ignore":
        return "Ignore";
      case "drop":
        return "Drop";
      default:
        return "Confirm";
    }
  };

  const getActionButtonColor = () => {
    switch (actionType) {
      case "resolve":
        return "bg-customGreen hover:bg-green-600";
      case "ignore":
        return "bg-yellow-500 hover:bg-yellow-600";
      case "drop":
        return "bg-red-500 hover:bg-red-600";
      default:
        return "bg-customGreen hover:bg-green-600";
    }
  };

  const toggleDropdown = (queryId) => {
    setActiveDropdown(activeDropdown === queryId ? null : queryId);
  };

  useEffect(() => {
    fetchRoleBasedUsers();
  }, []);

  return (
    <div className="bg-white rounded-[10px] p-5 w-full min-h-full shadow-sm">
      {/* Query Details */}

      <div className="grid grid-cols-2 gap-7 ">
 {selectedQuery ? (
        <div className="space-y-6 border border-slate-200 rounded-[10px] p-4" >
          {/* Query Header */}
          <div className="flex items-start justify-between">
            <div className="space-y-2">
              <h2 title={selectedQuery.title} className="text-[24px] line-clamp-2 truncate text-wrap font-semibold text-gray-800">
                {selectedQuery.title}
              </h2>
              
            </div>
            {selectedQuery.status === "PENDING" &&(<>
             {!isDropped && (<div className="relative">
              <div
                className="cursor-pointer p-2 hover:bg-gray-200 rounded-full"
                onClick={() => toggleDropdown(selectedQuery.id)}
              >
                <CiMenuKebab className="text-xl" />
              </div>
              {activeDropdown === selectedQuery.id && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-lg z-10">
                  <div className="absolute -top-2 right-4 w-4 h-4 bg-white rotate-45"></div>
                  <div className="py-2">
                    {!(selectedQuery.status === "RESOLVED" || selectedQuery.status === "DROPPED") && (
                      <>
                        <MenuItem
                          onClick={() => handleMenuClick(selectedQuery, "resolve")}
                          iconAlt={<FiCheckCircle className="text-green-600" />}
                          label="Resolve"
                        />
                        <Divider />
                        <MenuItem
                          onClick={() => handleMenuClick(selectedQuery, "ignore")}
                          iconAlt={<FiAlertCircle className="text-yellow-600" />}
                          label="Ignore Query"
                        />
                        <Divider />
                      </>
                    )}
                    <MenuItem
                      onClick={() => handleMenuClick(selectedQuery, "edit")}
                      iconAlt={<FiEdit className="text-blue-600" />}
                      label="Edit"
                    />
                    <Divider />
                    <MenuItem
                      onClick={() => handleMenuClick(selectedQuery, "drop")}
                      iconAlt={<FiXCircle className="text-red-600" />}
                      label="Drop Property"
                    />
                  </div>
                </div>
              )}
            </div>)}
            </>)}
            
           
            
          </div>

          {/* Query Description */}
          <div className="bg-gray-50 rounded-lg p-4">
            <h3 className="text-[16px] line-clamp-3 truncate text-wrap font-medium text-gray-800 mb-2">Description</h3>
            <p className="text-[14px] line-clamp-3 truncate text-wrap text-gray-700 leading-relaxed">
              {selectedQuery.description}
            </p>
             <h4 className="text-[14px] font-medium text-gray-600 mb-1">Given By</h4>
                <p className="text-[16px] text-gray-800">
                  {selectedQuery.givenBy?.name || "N/A"}
                  {selectedQuery.givenBy?.role && (
                    <span className="text-[12px] text-gray-500 ml-2">
                      ({selectedQuery.givenBy.role})
                    </span>
                  )}
                </p>
                 <h4 className="text-[14px] font-medium text-gray-600 mb-1">Created Date</h4>
                <p className="text-[16px] text-gray-800">
                  {selectedQuery.createdTimestamp ? (selectedQuery.createdTimestamp) : "N/A"}
                </p>
          </div>

        

          {/* Associated Legal Opinion */}
          {selectedQuery.associatedLegalOpinion && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <h4 className="text-[16px] font-medium text-blue-800 mb-2">Associated Legal Opinion</h4>
              <p className="text-[14px] text-blue-700">
                {selectedQuery.associatedLegalOpinion.type || ""}
              </p>
            </div>
          )}

          <div className="flex gap-2">
                <span
                  className={`px-3 py-1 flex items-center gap-2 rounded-full text-xs font-medium ${getPriorityBadgeColor(
                    selectedQuery.priority
                  )}`}
                >
                  {periotyQueryEnum.find((p) => p.value === selectedQuery.priority)?.icon || null}
                  {periotyQueryEnum.find((p) => p.value === selectedQuery.priority)?.label || null}
                </span>
                <span className="px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-600">
                  Category: {selectedQuery.category}
                </span>
                <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                  selectedQuery.status === "RESOLVED" ? "bg-green-100 text-green-600" :
                  selectedQuery.status === "IGNORED" ? "bg-yellow-100 text-yellow-600" :
                  selectedQuery.status === "DROPPED" ? "bg-red-100 text-red-600" :
                  "bg-gray-100 text-gray-600"
                }`}>
                  Status: {selectedQuery.status || ""}
                </span>
              </div>

          {/* File Attachment */}
          {selectedQuery.fileUrl && (
            <div className="bg-gray-50 rounded-lg p-4">
              <h4 className="text-[16px] font-medium text-gray-800 mb-2">Attached File</h4>
              <a
                href={selectedQuery.fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-800 transition-colors"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                View Document
              </a>
            </div>
          )}

          {/* Status Comments */}
          {selectedQuery.statusComment && (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <h4 className="text-[16px] font-medium text-yellow-800 mb-2">
                {selectedQuery.status === "RESOLVED" ? "Resolution" :
                 selectedQuery.status === "IGNORED" ? "Ignore Reason" :
                 "Drop Reason"}
              </h4>
              <p className="text-[14px] text-yellow-700">
                {selectedQuery.statusComment}
              </p>
            </div>
          )}
        </div>
      ) : (
        <div className="text-center text-gray-600 py-8">
          No query selected
        </div>
      )}
   <QueriesHistoryPage queryId={selectedQuery.id} />
     <QuertyAddReponseList queryId={selectedQuery.id} />
      </div>
     

    

   



      {/* Resolve/Ignore/Drop Modal */}
      <CustomModel
        isOpen={isResolveModalOpen}
        isClose={() => {
          setIsResolveModalOpen(false);
          setResolveComment("");
          setActionType(null);
        }}
        title={getActionTitle()}
        content={
          <div className="space-y-4">
            {selectedQuery && (
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <h3 className="font-medium text-gray-800 mb-2">Query Title</h3>
                <p className="text-gray-600 text-sm mb-2">
                  {selectedQuery?.title}
                </p>
                <p className="text-gray-500 text-xs">
                  {selectedQuery.description}
                </p>
                <div className="flex items-center gap-4 mt-3 text-xs text-gray-500">
                  <span>Given By: {selectedQuery.givenBy?.name || selectedQuery.givenByName || "N/A"}</span>
                </div>
                {actionType === "resolve" && (
                  <div className="flex items-center gap-2 mt-2 text-xs">
                    <span>
                      Resolved Date: {selectedQuery?.statusTimestamp ? formatToIndianDate(selectedQuery.statusTimestamp) : "N/A"}{" "}
                    </span>
                  </div>
                )}

                <div className="flex gap-2 mt-2">
                  <span
                    className={`px-2 py-1 flex items-center gap-1 rounded-full text-xs font-medium ${getPriorityBadgeColor(
                      selectedQuery.priority
                    )}`}
                  >
                    {periotyQueryEnum.find(
                      (p) => p.value === selectedQuery.priority
                    )?.icon || null}
                    {periotyQueryEnum.find(
                      (p) => p.value === selectedQuery.priority
                    )?.label || null}
                  </span>
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-600">
                    Category: {selectedQuery.category}
                  </span>
                </div>
              </div>
            )}

            <div className="space-y-2">
              <label className="text-sm font-medium text-gray-700">
                {actionType === "resolve"
                  ? "Resolve Comment"
                  : actionType === "ignore"
                  ? "Ignore Comment"
                  : "Drop Comment"}
              </label>
              <textarea
                rows={4}
                value={resolveComment}
                onChange={(e) => setResolveComment(e.target.value)}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
                placeholder="Type Comment"
              />
            </div>

            <div className="flex gap-3 pt-4">
              <button
                onClick={() => {
                  setIsResolveModalOpen(false);
                  setResolveComment("");
                  setActionType(null);
                }}
                className="flex-1 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmAction}
                className={`flex-1 py-2 text-white rounded-md transition-colors ${getActionButtonColor()}`}
              >
                {getActionButtonText()}
              </button>
            </div>
          </div>
        }
      />

      {/* Edit Query Modal */}
      <CustomSidebar
        visible={isEditModalOpen}
        onHide={() => {
          setIsEditModalOpen(false);
          setEditFormData({
            title: "",
            description: "",
            category: "",
            givenBy: "",
            targetDate: "",
            priority: "",
            associatedLegalOpinion: "",
            files: [],
          });
        }}
        title="Edit Query"
        width="600px"
      >
        <div className="space-y-4" >
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Category <span className="text-red-500">*</span>
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={queryCategories}
                value={editFormData.category || null}
                onChange={(selected) =>
                  handleEditSelectChange("category", selected)
                }
                placeholder="Select Query Category"
              />
            </div>
          </div>
          {editFormData.category?.value === "Advocate Analysis" && (
            <div className="grid grid-cols-12 items-center">
              <label className="col-span-4 text-sm font-medium text-gray-700">
                Advocate Opinion <span className="text-red-500">*</span>
              </label>
              <div className="col-span-8">
                <CustomAdvocateList
                  advocateOpinions={advocateOpinions}
                  selectedOpinionId={editFormData.associatedLegalOpinion?.value}
                  onChange={(selected) =>
                    handleEditSelectChange("associatedLegalOpinion", selected)
                  }
                  placeholder="Select Advocate Opinion"
                />
              </div>
            </div>
          )}
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Title
            </label>
            <div className="col-span-8">
              <input
                type="text"
                name="title"
                value={editFormData.title}
                onChange={handleEditInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
                placeholder="Enter query title"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Description
            </label>
            <div className="col-span-8">
              <textarea
                rows={4}
                name="description"
                value={editFormData.description}
                onChange={handleEditInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
                placeholder="Enter query description"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Priority
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={periotyQueryEnum}
                value={editFormData.priority || null}
                onChange={(selected) =>
                  handleEditSelectChange("priority", selected)
                }
                placeholder="Select Query Priority"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Query Given By
            </label>
            <div className="col-span-8">
              <CustomSelect
                options={users}
                value={editFormData.givenBy || null}
                onChange={(selected) =>
                  handleEditSelectChange("givenBy", selected)
                }
                placeholder="Select User"
              />
            </div>
          </div>
          <div className="grid grid-cols-12 items-center">
            <label className="col-span-4 text-sm font-medium text-gray-700">
              Target Date
            </label>
            <div className="col-span-8">
              <input
                type="date"
                name="targetDate"
                value={editFormData.targetDate}
                onChange={handleEditInputChange}
                className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-customGreen"
              />
            </div>
          </div>
          {editFormData.category?.value !== "Advocate Analysis" && (
            <MediaUpload
              mediaType={"document"}
              files={editFormData.files || []}
              onChange={(files) =>
                setEditFormData((prev) => ({ ...prev, files }))
              }
              accept="application/pdf,application/dwg,application/x-dwg,application/dxf,application/x-dxf"
              maxFiles={1}
              folderpath="AdvocateOpinion"
            />
          )}
          <button
            onClick={handleUpdateQuery}
            disabled={loading}
            className="w-full py-2 bg-customGreen text-white rounded-md disabled:opacity-50 hover:bg-green-600 transition-colors"
          >
            {loading ? "Updating..." : "Update Query"}
          </button>
        </div>
      </CustomSidebar>
    </div>
  );
};

export default QueriesInfoPage;